class Iva {
    
    intera = 1.22;
    ridotta = 1.10;
    soglia = 480;

}
export default new Iva();